document.addEventListener('keydown', (event) => {
  if (event.key !== 'Escape') return;
  document.querySelectorAll('.yz-mobile-menu[open], .yz-submenu[open]').forEach((menu) => {
    menu.open = false;
    menu.querySelector('summary')?.focus();
  });
});
document.addEventListener('click', (event) => {
  const link = event.target.closest('[data-yz-focus-search]');
  if (!link) return;
  const input = document.getElementById('yz-search');
  if (input) { event.preventDefault(); input.scrollIntoView({ block: 'center' }); input.focus({ preventScroll: true }); }
});
